var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "EyeButton DefaultHover",
      class: { disabled: _vm.disabled },
      style: { width: _vm.width, height: _vm.height }
    },
    [
      _c("svg-view", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.active,
            expression: "active"
          }
        ],
        attrs: { name: "eyeopen" }
      }),
      _vm._v(" "),
      _c("svg-view", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.active,
            expression: "!active"
          }
        ],
        attrs: { name: "eyeshut" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }